<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="this.$t('management_page.application_reason_approval_opinion_settings')")
    h2 {{$t('application_reason')}}
    .control-wrap
      .add
        b-row
          b-col.d-flex.align-items-center(cols="2") {{$t('add')}}
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.d-inline-block(v-model="reasonForm.title" size="sm")
            b-button(size="sm" @click="submit('reasonForm')")
              icon(name="plus")
      .list
        b-row
          b-col.d-flex.align-items-center(cols="2")
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.d-inline-block(size="sm" :placeholder="$t('manual_input')" :disabled="true")
        .scroll
          b-row(v-for="item of reasonList" :key="item.pk")
            b-col.d-flex.align-items-center(cols="2")
              b-button(size="sm" @click="changeOrder('reasonForm', item, 'up')")
                icon(name="arrow-up")
              b-button(size="sm" @click="changeOrder('reasonForm', item, 'down')")
                icon(name="arrow-down")
            b-col.d-flex.align-items-center(cols="10")
              b-form-input.d-inline-block(v-model="item.title" size="sm" :disabled="true")
              b-button(size="sm" @click="remove('reasonForm', item)")
                icon(name="minus")

    h2.mt-4 {{$t('management_page.approval_opinion')}}
    .control-wrap
      .add
        b-row
          b-col.d-flex.align-items-center(cols="2") {{$t('add')}}
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.d-inline-block(v-model="opinionForm.title" size="sm")
            b-button(size="sm" @click="submit('opinionForm')")
              icon(name="plus")
      .list
        b-row
          b-col.d-flex.align-items-center(cols="2")
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.d-inline-block(size="sm" :placeholder="$t('manual_input')" :disabled="true")
        .scroll
          b-row(v-for="item of opinionList" :key="item.pk")
            b-col.d-flex.align-items-center(cols="2")
              b-button(size="sm" @click="changeOrder('opinionForm', item, 'up')")
                icon(name="arrow-up")
              b-button(size="sm" @click="changeOrder('opinionForm', item, 'down')")
                icon(name="arrow-down")
            b-col.d-flex.align-items-center(cols="10")
              b-form-input.d-inline-block(v-model="item.title" size="sm" :disabled="true")
              b-button(size="sm" @click="remove('opinionForm', item)")
                icon(name="minus")
    .modal-footer
      b-btn(size="sm" @click="visible = false" pill) {{$t('submit')}}
</template>

<script>
import { ApprovalMacroAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.visible = newVal
        if (newVal) {
          this.fetchList(0)
          this.fetchList(1)
        }
      },
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      form: {},

      reasonList: [],
      opinionList: [],

      reasonForm: {
        title: "",
      },
      opinionForm: {
        title: "",
      },
    }
  },
  methods: {
    fetchList(request_type) {
      const params = { request_type }
      ApprovalMacroAPI.get("", { params }).then(res => {
        const { data } = res
        if (request_type === 0) {
          this.reasonList = data.objects.map((item, order) => ({ ...item, order }))
        } else {
          this.opinionList = data.objects
        }
      })
    },
    changeOrder(form, data, arrow) {
      const type = form === "reasonForm" ? 0 : 1

      const order = arrow === "up" ? data.order - 1 : data.order + 1
      _.find(this.reasonList, { order }).order = data.order
      _.find(this.reasonList, { pk: data.pk }).order = order

      this.reasonList = _.sortBy(this.reasonList, "order")

      const pk_line = _.map(this.reasonList, "pk").join(",")

      const params = {
        pk_line,
      }
      ApprovalMacroAPI.put("", params).then(res => {})
    },
    remove(form, item) {
      const type = form === "reasonForm" ? 0 : 1
      const params = {
        pk: item.pk,
      }
      ApprovalMacroAPI.delete("", { data: params }).then(res => {
        this.fetchList(type)
      })
    },
    submit(form) {
      if (_.isEmpty(this[form].title)) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: form === "reasonForm" ? this.$t('management_page.enter_application_reason') : this.$t('management_page.enter_approval_opinion') },
        })
        return
      }
      const type = form === "reasonForm" ? 0 : 1
      const params = {
        ...this[form],
        type,
        order: form === "reasonForm" ? this.reasonList.length + 1 : this.opinionList.length + 1,
      }
      ApprovalMacroAPI.post("", params).then(res => {
        this[form].title = ""
        this.fetchList(type)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  background-color: #f5f5f5;
  font-size: 15px;
  font-weight: 700;
  line-height: 35px;
  padding-left: 13px;
}
.add {
  padding-bottom: 20px;
}
.list {
  .row {
    padding-bottom: 10px;
  }
  .scroll {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 114px;
  }
}
.d-inline-block + button {
  margin-left: 10px;
}
</style>
